export const leadsConstants = {
    GET_ALL_LEADS_REQUEST: 'GET_ALL_LEADS_REQUEST',
    GET_ALL_LEADS_SUCCESS: 'GET_ALL_LEADS_SUCCESS',
    GET_ALL_LEADS_FAILURE: 'GET_ALL_LEADS_FAILURE',

    UPDATE_LEAD_REQUEST: 'UPDATE_LEAD_REQUEST',
    UPDATE_LEAD_SUCCESS: 'UPDATE_LEAD_SUCCESS',
    UPDATE_LEAD_FAILURE: 'UPDATE_LEAD_FAILURE',

    DELETE_LEAD_SUCCESS: 'DELETE_LEAD_SUCCESS',

    NEW_LEAD_FROM_STREAM: 'NEW_LEAD_FROM_STREAM'
}


// WEBPACK FOOTER //
// ./src/constants/leads.js